import script from "./MicButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MicButton.vue?vue&type=script&setup=true&lang=js"

import "./MicButton.vue?vue&type=style&index=0&id=0bcc8cc4&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bcc8cc4"]])

export default __exports__